import { Activityeditor } from '@linktivity/link-connect';
import config from '../config';

const activityApi = new Activityeditor.ActivityApi(config);

export default activityApi;
